export const formFields = [
  {
    section: "section 1",
    name: "pesScheduleName",
    label: "Schedule",
    fieldLabel: "PES Schedule Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "section 1",
    name: "pesScheduleDescription",
    label: "Description",
    fieldLabel: "PES Schedule Description",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [2, 1],
  },
  {
    section: "section 1",
    name: "pedScheduleSeq",
    label: "Sequence",
    fieldLabel: "PED Schedule Seq",
    type: "number",
    options: {
      required: { value: true, message: "REQUIRED" },
      min: { value: 1, message: "MIN_0" },
      max: { value: 999, message: "MAX_999" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [3, 1],
  },
  {
    section: "section 1",
    name: "pedType",
    label: "Type",
    fieldLabel: "PED Type",
    type: "dropdown",
    dropdownCondition: "*Valid List",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 1, message: "MAXLENGTH_1" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [4, 1],
  },
  {
    section: "section 1",
    name: "pedFromDate",
    label: "From",
    fieldLabel: "PED From Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [5, 1],
  },
  {
    section: "section 1",
    name: "pedThroughDate",
    label: "Thru",
    fieldLabel: "PED Through Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 1],
  },
  {
    section: "section 1",
    name: "pedStatus",
    label: "Status",
    fieldLabel: "Status Record Indicator",
    type: "dropdown",
    dropdownCondition: "*Values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [7, 1],
  },
  {
    section: "section 1",
    name: "pedStateList",
    label: "State List",
    fieldLabel: "PED State List",
    type: "lookup",
    externalProgram: { default: "RCSTL005" },
    viewType: "legacy",
    params: {
      lookupType: "external",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "pedStateList",
            target: "list",
            legacy: "stlStateListName",
            paramDataKey: "searchCriteria",
          },
          {
            source: "pedStateListDesc",
            target: "description",
            legacy: "stlStateListDesc",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "STATE_LIST",
    },
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "section 1",
    name: "pedStateListDesc",
    label: "",
    fieldLabel: "PED State List DESC ",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [8, 2],
  },

  {
    section: "section 1",
    name: "pedStateListIncExc",
    label: "I/E",
    fieldLabel: "/ Include/Exclude Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 3],
  },
  {
    section: "section 1",
    name: "pedPharmacyList",
    label: "Pharmacy List",
    fieldLabel: "PED Pharmacy List",
    type: "lookup",
    viewType: "legacy",
    externalProgram: { default: "RCPAL004" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "pedPharmacyList",
            target: "listName",
            legacy: "palPharmacyIdListName",
          },
          {
            source: "pedPharmacyListDesc",
            target: "listDesc",
            legacy: "palPharmacyIdListDesc",
          },
        ],
      },
    },
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "section 1",
    name: "pedPharmacyListDesc",
    label: "",
    fieldLabel: "PED Pharmacy List DESC ",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [9, 2],
  },
  {
    section: "section 1",
    name: "pedPharmacyListIncExc",
    label: "I/E",
    fieldLabel: "/ Include/Exclude Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 3],
  },
  {
    section: "section 1",
    name: "pedGpiMscList",
    label: "GPI MSC List",
    fieldLabel: "PED GPI MSC List",
    type: "lookup",
    externalProgram: { default: "RCGP3004" },
    viewType: "legacy",
    params: {
      lookupType: "external",
      viewType: "legacy",
      fieldMapping: {
        default: [
          {
            source: "pedGpiMscList",
            target: "level",
            legacy: "gp3GpiMscListId",
            paramDataKey: "searchCriteria",
          },
          {
            source: "pedGpiMscListDesc",
            target: "description",
            legacy: "gp3GpiMscListDesc",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "GPI_MSC_LIST",
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 1],
  },
  {
    section: "section 1",
    name: "pedGpiMscListDesc",
    label: "",
    fieldLabel: "PED GPI MSC List DESC ",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [10, 2],
  },
  {
    section: "section 1",
    name: "pedGpiMscListIncExc",
    label: "I/E",
    fieldLabel: "/ Include/Exclude Flag",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: { maxLength: { value: 1, message: "MAXLENGTH_1" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [10, 3],
  },
  {
    section: "section 1",
    name: "pedMacList",
    label: "MAC List",
    fieldLabel: "PED MAC List",
    type: "lookup",
    externalProgram: { default: "RCMCL005" },
    viewType: "legacy",
    params: {
      lookupType: "external",
      viewType: "legacy",
      extraParam: true,
      fieldMapping: {
        default: [
          {
            source: "pedMacList",
            target: "macList",
            legacy: "macList",
            paramDataKey: "description",
          },
          {
            source: "pedMacListDesc",
            target: "macListName",
            legacy: "macListName",
          },
        ],
      },
      appName: "ACCUMS",
      pageName: "MAC_LIST",
    },
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 30, message: "MAXLENGTH_30" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [14, 17],
  },
  {
    section: "section 1",
    name: "pedMacListDesc",
    label: "",
    fieldLabel: "PED MAC List DESC ",
    type: "text",
    options: { maxLength: { value: 30, message: "MAXLENGTH_30" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [14, 70],
  },
  {
    section: "section 1",
    name: "pedPharmacySuperNetwork",
    label: "Super Network",
    fieldLabel: "PED Pharmacy SuperNetwork",
    type: "lookup",
    viewType: "legacy",
    externalProgram: { default: "RCSNH990" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      apiFetch: true,
      apiFieldMapping: [
        { source: "networkId", legacy: "snhSuperNetworkId" },
        { source: "carrierId", legacy: "carCarrierId" },
        { source: "snhSeqNbr", legacy: "snhSeqNbr" },
        { source: "regionCode", legacy: "regRegionCode" },
        { source: "networkType", legacy: "snhNetworkType" },
      ],
      apiFieldInputs: [
        { source: "pedPharmacySuperNetwork", target: "networkId" },
        { source: "pedSnhSeqNbr", target: "snhSeqNbr" },
      ],
      fieldMapping: {
        default: [
          { source: "pedPharmacySuperNetwork", target: "networkId" },
          {
            source: "pedPharmacySuperNetworkDesc",
            target: "description",
          },
          { source: "pedSnhSeqNbr", target: "snhSeqNbr" },
          { source: "pedPharmacySuperNetworkCarrierId", target: "carrierId" },
          { source: "pedPharmacySuperNetworkRegionCode", target: "regionCode" },
        ],
      },
    },
    options: { maxLength: { value: 6, message: "MAXLENGTH_6" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [15, 17],
  },
  {
    section: "section 1",
    name: "pedPharmacySuperNetworkDesc",
    label: "",
    fieldLabel: "PED Pharmacy SuperNetwork DESC ",
    type: "text",
    options: {},
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [15, 70],
  },
  {
    section: "section 1",
    name: "pedRate",
    label: "Rate Percent %",
    fieldLabel: "PED Rate %",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 999.99, message: "MAX_999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [17, 19],
  },
  {
    section: "section 1",
    name: "pedShippingAmount",
    label: "Shipping Amount",
    fieldLabel: "PED Shipping Amount",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [18, 19],
  },
  {
    section: "section 1",
    name: "pedDispensingFee",
    label: "Dispensing Fee",
    fieldLabel: "PED Dispensing Fee",
    type: "number",
    fractionDigits: 2,
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 9999999.99, message: "MAX_9999999.99" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [19, 19],
  },
  {
    section: "Audit Fields",
    name: "addDateIso",
    label: "Added",
    fieldLabel: "ADD Date ISO",
    type: "date",
    format: "MM/DD/YYYY",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 20],
  },
  {
    section: "Audit Fields",
    name: "chgDateIso",
    label: "Changed",
    fieldLabel: "CHG Date ISO",
    type: "date",
    format: "MM/DD/YYYY",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 42],
  },
  {
    section: "Audit Fields",
    name: "chgUserName",
    label: "User",
    fieldLabel: "CHG User Name",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: Read-only",
    position: [21, 61],
  },
];
